var $ = require('jQuery');

module.exports = function() {
    // Sends a request to the server to generate a token and show the token immediately
    $('#generateToken').click(function() {
        $.post('/setting/generate-token', {}, function(token) {
            $('#apiToken').val(token);
        });
    });
};
